module.exports = __webpack_public_path__ + "static/img/intitu.6efa603.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/intitu.png
// module id = zB4U
// module chunks = 5